var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgToCbroom = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlSpace: "preserve",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.439 11.268a2.5 2.5 0 0 0 0-3.535l-5.172-5.172a2.48 2.48 0 0 0-1.767-.73c-.67 0-1.297.259-1.768.729L9.5 6.793l8.707 8.707zM3.732 20.439C4.607 21.314 6.262 22 7.5 22h2c1.237 0 2.893-.686 3.768-1.561l4.232-4.232L8.793 7.5l-7.232 7.232A2.48 2.48 0 0 0 .83 16.5c0 .67.26 1.297.73 1.768zM23.5 23H.5a.5.5 0 0 0 0 1h23a.5.5 0 0 0 0-1"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgToCbroom);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/TOCbroom.svg";